import React, { useContext } from 'react';
import { DeleteOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Input, Space, Tooltip } from 'antd';

import RemoteAccessAuditUsersContext from '@totem/components/services/remoteAccess/v2/audit/RemoteAccessAuditUsersContext';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { securityGroupCheckConstraintAny } from '@totem/components/userContext/security/userUtilities';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

type Props = {
  onRemoveSelected: () => void;
};

const RemoteAccessAuditUsersSearchBar = ({ onRemoveSelected }: Props) => {
  const { userProfile } = useContext(UserProfileContext);
  const {
    rows,
    emailSearch,
    setEmailSearch,
    nameSearch,
    setNameSearch,
    selectedUserIds,
    onRefresh,
  } = useContext(RemoteAccessAuditUsersContext);

  const isRemoteAccessAdmin = permissions.remoteAccessAdmin.hasPermissions(
    userProfile,
    securityGroupCheckConstraintAny,
  );

  return (
    <Space wrap size="middle" style={{ marginBottom: 16 }}>
      <RecordCountBadge count={rows.length} />
      <Input
        placeholder="Email Search"
        value={emailSearch}
        allowClear
        onChange={(evt) => setEmailSearch(evt.target.value)}
        style={{ width: 220 }}
      />
      <Input
        placeholder="Name Search"
        value={nameSearch}
        allowClear
        onChange={(evt) => setNameSearch(evt.target.value)}
        style={{ width: 220 }}
      />
      {isRemoteAccessAdmin && (
        <Button
          danger
          icon={<DeleteOutlined />}
          disabled={selectedUserIds.length === 0}
          onClick={onRemoveSelected}
        >
          Remove Selected ({selectedUserIds.length})
        </Button>
      )}
      <Tooltip title="Refresh">
        <Button icon={<ReloadOutlined />} onClick={onRefresh} />
      </Tooltip>
    </Space>
  );
};

export default RemoteAccessAuditUsersSearchBar;
